
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalImportStudentCsv from '@/components/templates/manage/ModalImportStudentCsv.vue'
import { ImportStudentsApi } from '@/api/methods/manage/ImportStudentsApi'
import { AcademiesApi } from '@/api/methods/manage/AcademiesApi'
import { ApiBadRequestAppError } from '@/models/AppErrorClasses'
import StringUtils from '@/utils/StringUtils'

/**
 * 生徒情報csvアップロードモーダル
 */
@Component({
  components: {
    ModalImportStudentCsv,
  },
})
export default class ModalImportStudents extends Vue {
  /** ユーザ情報モーダルのフォーマット */
  @Ref()
  modalImportStudentCsv!: ModalImportStudentCsv

  /** 塾ID */
  private academyId = 0

  /** csvファイル */
  private csvFile: File | null = null

  /**
   * csvファイルのセット
   *
   * @param files アップロードされたファイル
   */
  private setCsvFile(files: FileList | null): void {
    if (!files) {
      return
    }

    this.csvFile = files[0]
  }

  /**
   * 送信ボタンのdisabled制御
   *
   * @param mailAddress メールアドレス
   * @param fileSelected ファイルが選択済ならtrue
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(mailAddress: string, fileSelected: boolean): boolean {
    // メールアドレスが未入力の場合true
    if (StringUtils.isBlank(mailAddress)) {
      return true
    }

    // ファイルが未選択の場合true
    if (!fileSelected) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // 各項目のバリデーションチェック
    errorMessage = this.inputValidation()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 塾情報取得
    const academy = await AcademiesApi.getAcademy(this.academyId)

    try {
      await ImportStudentsApi.academyStudents(
        this.modalImportStudentCsv.mailAddress,
        academy.code,
        this.csvFile as File
      )
    } catch (error) {
      if (error instanceof ApiBadRequestAppError) {
        alert('ファイル内容の不正により失敗しました')
        this.$loading.complete()
        return
      }

      // 400エラー以外の場合は例外を投げ直し、共通処理に渡す
      this.$loading.complete()
      throw error
    }

    // 登録APIを追加
    this.$loading.complete()

    alert('アップロードが成功しました。受付完了メールをご確認下さい')

    // モーダルを閉じる
    this.hide()
  }

  /**
   * 登録項目のバリデーションチェック
   *
   * @returns 検証項目に該当：エラーメッセージ 全ての検証をパス：null
   */
  private inputValidation(): string | null {
    if (!this.modalImportStudentCsv.mailAddress.match(/.+@.+\..+/)) {
      return '入力されたメールアドレスが正しくありません'
    }

    const fileName = this.csvFile!.name
    if (!this.checkFileName(fileName)) {
      return '選択されたファイルがCSVではありません'
    }

    return null
  }

  /**
   * 選択ファイルの拡張子チェック
   *
   * @param fileName ファイル名
   * @returns csvファイルならtrue
   */
  private checkFileName(fileName: string): boolean {
    const extension = fileName.split('.').pop()
    // 拡張子が存在し、かつ 'csv' と一致する場合のみ true を返す
    return extension ? extension.toLowerCase() === 'csv' : false
  }

  /**
   * モーダルを開く
   *
   * @param academyId 塾ID
   */
  public show(academyId: number): void {
    // 塾IDを設定
    this.academyId = academyId

    // モーダルを開く
    this.modalImportStudentCsv.show()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalImportStudentCsv.hide()
  }
}
